export default __webpack_public_path__ + "static/media/logo2.d0718d3a.svg";